<template>
  <g
    v-show="isVisualizationLayerShown"
    :transform="spotPosition"
  >
    <g @click.stop="showDetail">
      <visualization-pin-restroom-male
        v-if="isRestroom && spot.gender === 'male'"
        x="0"
        y="0"
        :width="visualizationPinSize.width"
        :height="visualizationPinSize.height"
        :transform="visualizationPinTransform"

        :is-searched="isVisualizationPinSearched"
        :is-selected="isVisualizationPinSelected"
      />

      <visualization-pin-restroom-female
        v-else-if="isRestroom && spot.gender === 'female'"
        x="0"
        y="0"
        :width="visualizationPinSize.width"
        :height="visualizationPinSize.height"
        :transform="visualizationPinTransform"

        :is-searched="isVisualizationPinSearched"
        :is-selected="isVisualizationPinSelected"
      />

      <visualization-pin-restroom-shared
        v-else-if="isRestroom && spot.gender === 'shared'"
        x="0"
        y="0"
        :width="visualizationPinSize.width"
        :height="visualizationPinSize.height"
        :transform="visualizationPinTransform"

        :is-searched="isVisualizationPinSearched"
        :is-selected="isVisualizationPinSelected"
      />

      <visualization-pin-dome
        v-else-if="spot.type.indexOf('Dome') >= 0"
        x="0"
        y="0"
        :width="visualizationPinSize.width"
        :height="visualizationPinSize.height"
        :transform="visualizationPinTransform"

        :is-searched="isVisualizationPinSearched"
        :is-selected="isVisualizationPinSelected"
      />

      <visualization-pin-defeult
        v-else
        x="0"
        y="0"
        :width="visualizationPinSize.width"
        :height="visualizationPinSize.height"
        :transform="visualizationPinTransform"

        :is-searched="isVisualizationPinSearched"
        :is-selected="isVisualizationPinSelected"
      />
    </g>

    <icon-full
      v-if="isRestroom"
      x="0"
      y="0"
      :visualization-pin-size="visualizationPinSize"
      :visualization-pin-scale="visualizationPinScale"
      :is-searched="isVisualizationPinSearched"
      :is-selected="isVisualizationPinSelected"
      :spot="spot"
    />

    <text
      x="0"
      :y="textTop"
      stroke="#fff"
      stroke-linejoin="round"
      :stroke-width="borderSize"
      :font-size="textSize"
      text-anchor="middle"
    >
      {{ spot.name }}
    </text>

    <text
      x="0"
      :y="textTop"
      :font-size="textSize"
      text-anchor="middle"
      fill="#6c6c6c"
      font-weight="bold"
    >
      {{ spot.name }}
    </text>
  </g>
</template>

<script>
import map from '@/mixins/map.js';
import iconFull from './icon_full.vue';
import visualizationPinDefeult from './default.vue';
import visualizationPinRestroomMale from './restroom_male.vue';
import visualizationPinRestroomFemale from './restroom_female.vue';
import visualizationPinRestroomShared from './restroom_shared.vue';
import visualizationPinDome from './dome.vue';

export default {
  components: {
    iconFull,
    visualizationPinDefeult,
    visualizationPinRestroomMale,
    visualizationPinRestroomFemale,
    visualizationPinRestroomShared,
    visualizationPinDome,
  },
  mixins: [map],
  props: {
    spot: {
      type: Object,
      default() {
        return null;
      },
    },
  },
  computed: {
    mapZoomLevel: ({ $store }) => $store.state.map.zoomLevel,
    spotPosition: ({ $store, spot }) => `translate(${spot.positionX} -${spot.positionY}) scale(${1 / $store.state.map.scale})`,
    isRestroom: ({ spot }) => spot.type.indexOf('Restroom') >= 0,
    // NOTE: 検索結果
    destinationList: ({ $store }) => $store.state.searchResult.destinations,
    // NOTE: 地図の縮尺によって表示・非表示の判定
    isVisualizationLayerShown: ({ mapZoomLevel }) => () => mapZoomLevel >= 1 && mapZoomLevel <= 8,
    // TODO: 仕様が決まってないためすべて表示するようにしている
    // isVisualizationLayerShown: ({ mapZoomLevel }) => (spot) => spot.showLevelMin <= mapZoomLevel && mapZoomLevel <= spot.showLevelMax,
    // NOTE: 基準となるアイコンのサイズを決める
    visualizationPinSize() {
      if (!this.svgElm) {
        return {
          width: 0,
          height: 0,
        };
      }

      // NOTE: 表示上何pxにしたいかの数値を引数に書く
      return {
        width: this.pxToSvgSize(48),
        height: this.pxToSvgSize(54.32),
      };
    },
    // NOTE: 検索結果に含まれているか
    isVisualizationPinSearched: ({ destinationList, spot }) => destinationList.some((result) => {
      if (result.type.indexOf('Spot') < 0) return false;
      return result.id === spot.id;
    }),
    // NOTE: 選択中か否か
    isVisualizationPinSelected() {
      const { destination } = this.$store.state.searchResult;
      return destination.id === this.spot.id && destination.type === this.spot.type;
    },
    // NOTE: 選択中のスポットはサイズを大きくする
    visualizationPinScale: ({ isVisualizationPinSelected }) => ((isVisualizationPinSelected) ? 2.5 : 1),
    // NOTE: ピンの先端を座標に合わせる
    visualizationPinTransform() {
      const width = -this.visualizationPinSize.width / 2;
      const height = -this.visualizationPinSize.height;
      return `scale(${this.visualizationPinScale}) translate(${width}, ${height})`;
    },
    // NOTE: テキストをアイコンの上部に持ってくる
    textTop() {
      return -this.visualizationPinSize.height * this.visualizationPinScale - this.visualizationPinSize.height * this.visualizationPinScale * 0.1;
    },
    // NOTE: テキストの文字サイズ
    textSize() {
      if (!this.svgElm) return 0;

      let fontSize = 0;
      if (this.isVisualizationPinSelected) {
        return this.pxToSvgSize(20);
      } else {
        return this.pxToSvgSize(9);
      };
    },
    // NOTE: テキストの枠線の太さ
    borderSize() {
      return this.textSize / 2;
    },
  },
  methods: {
    showDetail() {
      // NOTE: 仲居さんとの共通メソッド
      this.$store.commit('current/switchGroupSelected', false);
      this.$store.commit('current/setDestination', this.spot);
      this.$store.dispatch('searchResult/getSpot', this.spot.id);
      this.$store.dispatch('destinationDetail/show');

      // NOTE: 女将さん固有メソッド
      this.$store.dispatch('map/switchShiftMap', this.spot.positionX);
      this.$store.dispatch('appNavigator/updateNoOperationTimer', this.$store.state.appNavigator.noOperationTimer);
      this.$store.dispatch('searchResult/clearDestinations');
    },
  },
};
</script>



// WEBPACK FOOTER //
// base.vue?282dc00f